import React, { Component }  from 'react';
import { connect } from 'react-redux';
import { CardWarning } from '../../../widgets/Cards';
import { fetchWarning } from '../../../../actions';




class Warning extends Component {

    constructor(props) {
        super(props);
        this.state = {
            warningList: this.props.fetchWarning(this.props.patient._id)
        };
    };

    // componentDidMount() {
    //     this.props.fetchWarning(this.props.patient._id)
    // }

    // componentDidUpdate() {
    //     this.props.fetchWarning(this.props.patient._id)
    // }

    contentList() {
        
        var warningList = this.props.warning;
            return warningList.map( item => {
                return (
                <div>{item.message}<br></br></div>
                )
            })
    }

    content() {
        return (
            <>
            <h2 style={{marginTop:"-10px"}}>Warning</h2>
            {this.contentList()}
            </>
        )
    }

    render() {
        return (
            <CardWarning
                color = "red"
                content = {this.content()}
                icon ='bell'
            />
        )
        
    }
}

const mapStateToProps = (state) => {
    return { 
        warning : Object.values(state.warning),
        patient : state.selectedPatient,
    }
}

export default connect(mapStateToProps, {fetchWarning})(Warning);

